import moment from 'moment'
import { SamplePack } from '@arpeggi/shared'

const preSaleLive = (sp: SamplePack): boolean => {
  return (
    sp?.edition?.hasPresale &&
    sp?.edition?.preSaleStartTime &&
    sp?.edition?.preSaleEndTime &&
    moment() > moment(sp.edition.preSaleStartTime) &&
    moment() < moment(sp.edition.preSaleEndTime)
  )
}

const publicSaleLive = (sp: SamplePack): boolean => {
  return (
    sp?.edition?.publicSaleStartTime &&
    sp?.edition?.publicSaleEndTime &&
    moment() > moment(sp.edition.publicSaleStartTime) &&
    moment() < moment(sp.edition.publicSaleEndTime)
  )
}

export const saleIsLive = (sp: SamplePack, isPresale: boolean) =>
  isPresale ? preSaleLive(sp) : publicSaleLive(sp)